#include <dithering_fragment>
float h = uHeatFallof;

float heatDistance = distance(vPositionW, uHeatSource) * 1.01;
heatDistance *= uHeatDistance;
heatDistance = clamp(1. - heatDistance, 0., 1.);
heatDistance = pow(heatDistance, 30.);
// float heatDistance = 0.1;

vec4 hard = gl_FragColor * hardenedColor;
float hardenedUv = smoothstep(uHardened - 0.025, uHardened + 0.025, vUv.y);
gl_FragColor = mix(gl_FragColor, hard, clamp(vColor.r * 4., 0., 1.) * hardenedUv);
// gl_FragColor = gl_FragColor + vColor * middleColor * uHeat * heatDistance;
vec4 glow = vColor * middleColor * uHeat * heatDistance * 2.;
gl_FragColor = mix(gl_FragColor, gl_FragColor * 0.7 + glow, glow.r);
// gl_FragColor = glow;
// gl_FragColor = vec4(vec3(heatDistance), 1.);